import { createReducer } from '@reduxjs/toolkit';
import { showForm, triggerModalRecompute, performedModalRecompute } from '../actions/navigation';

const initialState = {
  showForm: 'home',
  shouldRecomputeModal: false,
};

export default createReducer(initialState, {
  [showForm]: (state, action) => ({
    ...state,
    showForm: action.payload,
  }),
  [triggerModalRecompute]: (state) => ({
    ...state,
    shouldRecomputeModal: true,
  }),
  [performedModalRecompute]: (state) => ({
    ...state,
    shouldRecomputeModal: false,
  }),
});
